export default "__VITE_ASSET__CGX03Nff__"